import { IConfigsType } from '../../types'

const wingitnorthConfig: IConfigsType = {
  wingitnorth: {
    '/:brand/systemwide_overview': {
      groupFilter: {
        api: 'corporateFilter',
      },
      dateFilter: {
        types: [
          'week',
          'period',
          'quarter',
          'year',
          'last_week',
          'this_week',
          'yesterday',
          'trailing_7_days',
          'trailing_90_days',
          'custom',
        ],
      },
      systemwideOverview: {
        type: 'list',
        api: 'systemwideOverviewKpis',
        title: 'Systemwide Overview',
        fieldWidth: '120px',
        fields: [
          {
            content: {
              key: 'netSales',
            },
            bottom: 'Total Sales',
          },
          {
            content: {
              key: 'netSalesSssPercent',
              decimal: 1,
            },
            bottom: 'YoY %',
          },
          {
            content: {
              key: 'netSalesBudgetVariance',
            },
            bottom: 'Net Sales Budget Variance',
          },
          {
            content: {
              key: 'checkCount',
            },
            bottom: 'Check Count',
          },
          {
            content: {
              key: 'checkCountVsLyPercent',
            },
            bottom: 'Check Count % vs LY',
          },
          {
            content: {
              key: 'checkAverage',
              decimal: 2,
            },
            bottom: 'Check Average',
          },
          {
            content: {
              key: 'hourlyLaborCostPercent',
              decimal: 1,
            },
            bottom: 'Labor Percent',
          },
          {
            content: {
              key: 'hourlyLaborBudgetVariance',
              decimal: 1,
            },
            bottom: 'Labor Budget Variance',
          },
          {
            content: {
              key: 'avtPercent',
              decimal: 1,
            },
            bottom: 'AvT',
          },
          {
            content: {
              key: 'cogsPercent',
              decimal: 1,
            },
            bottom: 'COGS',
          },
          {
            content: {
              key: 'cogsBudgetVariance',
              decimal: 1,
            },
            bottom: 'COGS Budget Variance',
          },
        ],
      },
      breakdownByStore: {
        type: 'table',
        api: 'systemwideOverview',
        title: 'Breakdown by Store',
        pageSize: 20,
        groupInfo: {
          width: '200px',
          groupBy: {
            width: '200px',
          },
        },
        columns: [
          {
            key: 'Sales',
            title: 'Net Sales',
            align: 'center',
            highlight: true,
            children: [
              {
                key: 'netSales',
                title: '$',
                align: 'center',
                sortable: true,
              },
              {
                key: 'netSalesBudgetVariance',
                title: 'Variance',
                align: 'center',
                sortable: true,
              },
              {
                key: 'netSalesSssPercent',
                title: 'YoY %',
                align: 'center',
                sortable: true,
                decimal: 1,
              },
            ],
          },
          {
            key: 'Labor',
            title: 'Labor',
            align: 'center',
            children: [
              {
                key: 'hourlyLaborCostPercent',
                title: '%',
                align: 'center',
                sortable: true,
                decimal: 1,
              },
              {
                key: 'hourlyLaborBudgetVariance',
                title: 'Variance',
                align: 'center',
                sortable: true,
                decimal: 1,
              },
            ],
          },
          {
            key: 'COGS',
            title: 'COGS',
            align: 'center',
            children: [
              {
                key: 'cogsPercent',
                title: '%',
                align: 'center',
                sortable: true,
                decimal: 1,
              },
              {
                key: 'cogsBudgetVariance',
                title: 'Variance',
                align: 'center',
                sortable: true,
                decimal: 1,
              },
              {
                key: 'avtPercent',
                title: 'AvT',
                align: 'center',
                sortable: true,
                decimal: 1,
              },
            ],
          },
        ],
      },
      revenueCenterAndDayPart: {
        type: 'grid',
        children: {
          revenueCenter: {
            type: 'table-v2',
            api: 'locationGroupRevenueCenter',
            title: 'Revenue Center',
            columns: [
              {
                key: 'name',
                title: 'Revenue Center',
                sortable: true,
              },
              {
                key: 'sales',
                title: 'Net Sales',
                unit: 'dollar',
                sortable: true,
              },
              {
                key: 'percentSales',
                title: '% Net Sales',
                sortable: true,
              },
              {
                key: 'checkCount',
                title: 'Check Count',
                sortable: true,
              },
              {
                key: 'checkAverage',
                title: 'Check Average',
                unit: 'dollar',
                decimal: 2,
                sortable: true,
              },
            ],
          },
          dayPart: {
            type: 'table-v2',
            api: 'locationGroupDayPart',
            title: 'Day Part',
            columns: [
              {
                key: 'name',
                title: 'Day Part',
                sortable: true,
              },
              {
                key: 'sales',
                title: 'Sales',
                unit: 'dollar',
                sortable: true,
              },
              {
                key: 'percentSales',
                title: '% Net Sales',
                sortable: true,
              },
              {
                key: 'checkCount',
                title: 'Check Count',
                sortable: true,
              },
              {
                key: 'checkAverage',
                title: 'Check Average',
                unit: 'dollar',
                decimal: 2,
                sortable: true,
              },
            ],
          },
        },
      },
      map: {
        type: 'map',
        api: 'listGeoInfo',
      },
      chatbox: {
        type: 'chatbox-v2',
        agentCode: 'systemwide-overview',
        sendStoreId: false,
      },
      feV2ChatBox: {
        type: 'feV2-chatbox',
        agentType: 'location',
        hideFromNonExpoUsers: true,
        disableInputField: false,
        sendStoreId: false,
        description: 'Ask about sales performance',
        bubblePrompts: [
          {
            id: 'sales',
            label: 'Sales',
            prompt: 'Show me the sales performance',
            children: [
              {
                id: 'yesterday',
                label: 'Yesterday',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'yesterday',
                },
                prompt: 'yesterday',
              },
              {
                id: 'sales_7days',
                label: '7 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_7days',
                },
                prompt: 'over the past 7 days',
              },
              {
                id: 'sales_30days',
                label: '30 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_30days',
                },
                prompt: 'over the past 30 days',
              },
              {
                id: 'sales_90days',
                label: '90 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_90days',
                },
                prompt: 'over the past 90 days',
              },
            ],
            agentCode: 'prompt:sales',
          },
          {
            id: 'daypart',
            label: 'Day Part',
            prompt: 'Show me the sales performance by day part',
            children: [
              {
                id: 'yesterday',
                label: 'Yesterday',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'yesterday',
                },
                prompt: 'yesterday',
              },
              {
                id: 'daypart_7days',
                label: '7 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_7days',
                },
                prompt: 'over the past 7 days',
              },
              {
                id: 'daypart_30days',
                label: '30 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_30days',
                },
                prompt: 'over the past 30 days',
              },
              {
                id: 'daypart_90days',
                label: '90 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_90days',
                },
                prompt: 'over the past 90 days',
              },
            ],
            agentCode: 'prompt:sales-daypart',
          },
          {
            id: 'revenue-center',
            label: 'Revenue Center',
            prompt: 'Show me the sales performance by revenue center',
            children: [
              {
                id: 'yesterday',
                label: 'Yesterday',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'yesterday',
                },
                prompt: 'yesterday',
              },
              {
                id: 'revenue-center_7days',
                label: '7 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_7days',
                },
                prompt: 'over the past 7 days',
              },
              {
                id: 'revenue-center_30days',
                label: '30 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_30days',
                },
                prompt: 'over the past 30 days',
              },
              {
                id: 'revenue-center_90days',
                label: '90 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_90days',
                },
                prompt: 'over the past 90 days',
              },
            ],
            agentCode: 'prompt:sales-revenue-center',
          },
        ],
      },
    },
  },
}

export default wingitnorthConfig
